import React from 'react';
/**
 * @deprecated utiliser `SearchBarV2`. Sera supprimé dans une futur Release d'ici fin 2025.
 */
var BarreRecherche = React.forwardRef(function (_a, ref) {
    var _b = _a.name, name = _b === void 0 ? "barre-recherche" : _b, _c = _a.placeholder, placeholder = _c === void 0 ? "Rechercher" : _c, _d = _a.texteBouton, texteBouton = _d === void 0 ? "Rechercher" : _d, onChange = _a.onChange, onBlur = _a.onBlur, onClickRecherche = _a.onClickRecherche, taille = _a.taille;
    var onClick = function (e) {
        if (onClickRecherche) {
            onClickRecherche(e);
        }
    };
    var classSearchBar = 'fr-search-bar';
    if (taille) {
        classSearchBar += " fr-search-bar--".concat(taille);
    }
    return (React.createElement("div", { className: classSearchBar, id: "header-search", role: "search" },
        React.createElement("label", { className: "fr-label", htmlFor: "bouton-barre-recherche-input" }, placeholder),
        React.createElement("input", { 
            // @ts-ignore
            ref: ref, name: name, onChange: onChange, onBlur: onBlur, className: "fr-input", placeholder: placeholder, type: "search", id: "bouton-barre-recherche-input" }),
        React.createElement("button", { className: "fr-btn", title: "Rechercher", onClick: onClick }, texteBouton)));
});
export default BarreRecherche;
